<template>
  <v-col cols="12" sm="12" md="4" class="d-flex">
    <v-card class="elevation-1 flex-grow-1">
      <v-toolbar color="white">
        <v-toolbar-title class="text-md-subtitle-1">
          <span> Agents with Overdue Referrals</span>
          <v-btn
            icon="fa-regular fa-circle-info"
            variant="text"
            aria-label="info"
            color="btncolor"
            @click="showToolTip"
          >
          </v-btn>
        </v-toolbar-title>
      </v-toolbar>
      <v-container px-0 fluid class="agents-overdue-referrals-table-container">
        <v-row v-if="loading" align="center" justify="center">
          <v-col class="pt-0">
            <div class="dashboard-widget-progress-container">
              <v-progress-circular
                :size="75"
                :width="8"
                class="my-auto"
                color="primary"
                indeterminate
              />
            </div>
          </v-col>
        </v-row>

        <v-row v-else>
          <v-col pt-0>
            <!-- LEFT OFF HERE -->
            <overview-overdue-referrals-clear-component
              v-if="agents.length === 0"
            />
            <v-data-table-server
              v-else
              style="width: 100%"
              class="elevation-0 agents-overdue-referrals-table px-0"
              :headers="headers"
              :items="agents"
              :items-length="totalAgents"
              :loading="loading"
              :mobile="false"
              return-object
            >
              <template #item="props">
                <tr class="no-hover px-0">
                  <td
                    class="px-0 py-2"
                    style="
                      overflow: hidden;
                      white-space: nowrap;
                      text-overflow: ellipsis;
                    "
                  >
                    <v-list-item class="px-0">
                      <v-row class="flex-nowrap" style="min-width: auto">
                        <v-col cols="auto" class="pr-1 d-xs-none">
                          <v-avatar
                            color="red-darken-2"
                            class="px-4 avatar-center"
                            style="min-width: unset"
                          >
                            <span class="text-white text-h6">{{
                              props.item.avatar
                            }}</span>
                          </v-avatar>
                        </v-col>
                        <v-col cols="9">
                          <v-list-item-title
                            style="font-size: 14px"
                            class="text-truncate font-weight-light"
                            >{{ props.item.name }}</v-list-item-title
                          >
                          <v-list-item-subtitle class="font-weight-light">
                            <span class="text-red-darken-2 font-weight-medium">
                              {{ props.item.maxDaysOverdue }}
                            </span>
                            {{ props.item.maxDaysOverdue > 1 ? "days" : "day" }}
                            overdue</v-list-item-subtitle
                          >
                        </v-col>
                      </v-row>
                    </v-list-item>
                  </td>

                  <td class="px-0 text-right">
                    <!--                    <v-row>-->
                    <v-col cols="auto" class="pr-0">
                      <span class="text-red-darken-2 px-0 text-h6">{{
                        props.item.overdueForFollowup
                      }}</span>
                    </v-col>
                    <!--                    </v-row>-->
                  </td>
                </tr>
              </template>
              <!-- remove bottom pagination -->
              <template #bottom></template>
            </v-data-table-server>
          </v-col>
        </v-row>
      </v-container>
      <v-divider />
      <v-card-actions v-if="!loading">
        <v-spacer />
        <v-btn
          variant="text"
          color="btncolor"
          class="my-auto text-none"
          @click="viewAllAgents"
        >
          {{ viewAllAgentsButtonText }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-col>
</template>

<script>
import api from "@/services/api.js";
import { mapGetters, mapMutations } from "vuex";
import useAuthMixin from "@/mixins/auth.js";
import { defineAsyncComponent } from "vue";

export default {
  name: "console-overview-overdue-referrals",
  components: {
    OverviewOverdueReferralsClearComponent: defineAsyncComponent(
      () => import("./OverviewOverdueReferralsClearComponent"),
    ),
  },
  props: {
    // collapsed: {
    //   type: Boolean,
    //   value: false,
    // },
  },
  computed: {
    ...mapGetters("user", ["myBrokerage"]),
    ...mapGetters("auth", ["impBrokerage"]),
    viewAllAgentsButtonText() {
      return this.totalAgents > 0
        ? `View All ${this.totalAgents} Active Agents`
        : "View All Active Agents";
    },
  },
  data() {
    return {
      headers: [
        {
          title: "Name",
          value: "name",
          key: "name",
          sortable: false,
          align: "start",
        },
        {
          title: "# Referrals",
          value: "overdueForFollowup",
          key: "overdueForFollowup",
          sortable: false,
          align: "end",
          width: "25%",
          class: "referrals-th",
        },
        // {
        //   text: "Days Overdue",
        //   value: "maxDaysOverdue",
        //   sortable: false,
        //   align: "right",
        //   class: this.collapsed ? "d-none" : "hidden-sm-and-down",
        // },
      ],
      loading: true,
      agents: [],
      totalAgents: 0,
      toolTip: null,
      toolTipDialog: false,
    };
  },
  methods: {
    ...useAuthMixin(),
    ...mapMutations("user", ["setMyAgentsSort", "setMyAgentsSortDesc"]),
    async loadAllReferrals() {
      try {
        let { resp } = await api.getAgents(0, 1);
        this.totalAgents = resp.data.totalElements;
      } catch (e) {
        this.errorCheck(e);
      }
    },
    async loadOverdueReferrals() {
      this.loading = true;
      let sort = "funnelStatus.overdueForFollowupCount,DESC";
      let index = 0;
      let rowsPerPage = 5;

      try {
        let { resp } = await api.getAgents(index, rowsPerPage, sort);
        this.processOverdueAgents(resp.data.content);
      } catch (e) {
        console.log(e);
        this.loading = false;
        this.errorCheck(e);
      }
    },
    processOverdueAgents(agents) {
      this.agents = [];
      for (let i = 0; i < agents.length; i++) {
        if (agents[i].funnelStatus.stages.overdueForFollowup.count > 0) {
          // name logic to best display the values available
          let name = "Not Available";
          if (agents[i].name.display) {
            let name = agents[i].name.display;
            name = name.replace(/^./, name[0].toUpperCase());
          }
          if (
            agents[i].name.first &&
            agents[i].name.first !== "" &&
            agents[i].name.last &&
            agents[i].name.last !== ""
          ) {
            let firstName = agents[i].name.first;
            let lastName = agents[i].name.last;

            firstName = firstName.replace(/^./, firstName[0].toUpperCase());
            lastName = lastName.replace(/^./, lastName[0].toUpperCase());

            name = `${firstName} ${lastName}`;
          } else if (agents[i].name.first && agents[i].name.first !== "") {
            let firstName = agents[i].name.first;
            firstName = firstName.replace(/^./, firstName[0].toUpperCase());
            name = `${firstName}`;
          } else if (agents[i].name.last && agents[i].name.last !== "") {
            let lastName = agents[i].name.last;
            lastName = lastName.replace(/^./, lastName[0].toUpperCase());
            name = `${lastName}`;
          }

          let agent = {
            avatar: name[0].toUpperCase(),
            name: name,
            overdueForFollowup:
              agents[i].funnelStatus.stages.overdueForFollowup.count,
            maxDaysOverdue: agents[i].funnelStatus.stages.maxDaysOverdue.count,
          };

          this.agents.push(agent);
        }
      }

      this.loading = false;
    },
    viewAllAgents() {
      this.setMyAgentsSort("overdue");
      this.setMyAgentsSortDesc(true);

      this.$router.push("/console/my-agents");
    },
    showToolTip() {
      this.$emit("toolTip", "OverviewOverdueReferralsToolTip");
    },
  },
  mounted() {
    this.loadOverdueReferrals();
    this.loadAllReferrals();
  },
};
</script>

<style scoped>
/*.truncate-cell {*/
/*  max-width: 1px;*/
/*}*/
.agents-overdue-referrals-table-container {
  min-height: 420px;
}

.agents-overdue-referrals-table :deep(table) {
  width: 100%;
  table-layout: fixed;
}
.agents-overdue-referrals-table :deep(table thead tr th) {
  border-bottom: none !important;
  border-top: none !important;
  border-color: #ffffff !important;
  font-size: 14px;
  font-weight: 500;
  white-space: nowrap;
}
.agents-overdue-referrals-table :deep(.referrals-th) {
  width: 30%;
}

.agents-overdue-referrals-table :deep(th.active) {
  color: #4a90e2 !important;
  font-weight: 600 !important;
}

.agents-overdue-referrals-table :deep(table tbody tr) {
  font-size: 14px !important;
}
.agents-overdue-referrals-table :deep(table tbody tr td) {
  border-bottom: none !important;
  border-top: none !important;
  border-color: #ffffff !important;
  font-size: 14px !important;
}
.agents-overdue-referrals-table :deep(.v-table tbody tr:not(:first-child) td) {
  /*padding-top: 16px !important;*/
}
.agents-overdue-referrals-table :deep(table tbody tr:hover) {
  /*background-color: #f5f5f5 !important;*/
  background-color: unset !important;
}
/*.agents-overdue-referrals-table >>> table tbody tr td:first-child {*/
/*  width: 200px;*/
/*}*/

/*.agents-overdue-referrals-table .v-table tbody tr {*/
/*  border-bottom: none !important;*/
/*  height: 65px;*/
/*}*/
/*.agents-overdue-referrals-table .v-table tbody tr {*/
/*  border-bottom: none !important;*/
/*  height: 65px;*/
/*}*/
/*.agents-overdue-referrals-table >>> .theme--light.v-table thead,*/
/*.agents-overdue-referrals-table >>> .theme--light.v-table thead tr:first-child {*/
/*  border-bottom: none !important;*/
/*}*/
/*.agents-overdue-referrals-table >>> .theme--light.v-table tbody {*/
/*  box-shadow: none !important;*/
/*  -webkit-box-shadow: none !important;*/
/*}*/
/*.agents-overdue-referrals-table >>> .v-table thead tr th {*/
/*  font-size: 16px !important;*/
/*  font-weight: 500 !important;*/
/*  !*padding: 0 4px 4px 4px !important;*!*/
/*}*/
/*.agents-overdue-referrals-table >>> .v-table tbody tr {*/
/*  border-bottom: none !important;*/
/*  border-color: #ffffff !important;*/
/*}*/
/*.lead-progression-table .v-table tbody tr td {*/
/*  font-size: 14px;*/
/*  font-weight: 400;*/
/*  padding: 0 4px 16px 4px !important;*/
/*}*/
/*.agents-overdue-referrals-table .v-table tbody tr:not(:first-child) td {*/
/*  !*padding-top: 16px !important;*!*/
/*}*/
/*.agents-overdue-referrals-table >>> .v-table tbody tr:hover {*/
/*  background-color: #f5f5f5 !important;*/
/*}*/

.v-data-table {
  background: transparent;
}
.v-data-table :deep(.v-data-table-header__sort-icon) {
  font-size: unset;
  margin-left: 4px;
}

.v-data-table :deep(.v-data-table-header__content) {
  font-weight: 400;
}
.v-data-table :deep(.v-data-table__th) {
  padding: 0 !important;
}
/* Style specific table headers */
/* Status header */
:deep(table th:not(:last-child :first-child)) {
  padding-left: 4px !important;
}

/* Slotted header hover sort handling */
:deep(table th .header-hover:hover .header-icon) {
  opacity: 0.5 !important;
  font-size: unset;
  margin-left: 4px;
}
:deep(table th .header-hover .header-icon) {
  opacity: 0;
}
:deep(table th.v-data-table__th--sorted .header-hover .header-icon) {
  opacity: 1 !important;
  font-size: unset;
  margin-left: 4px;
}
:deep(table th.v-data-table__th--sorted:hover .header-hover .header-icon) {
  opacity: 1;
  font-size: unset;
  margin-left: 4px;
}
</style>
